import { SegmentGroup } from '@components'
import { A, useLocation } from '@solidjs/router'
import { For, createEffect, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { useSingle } from './state'

export const Menu = (props: SegmentGroup.RootProps) => {
	const [path, setPath] = createSignal<string | undefined>()
	const { isArchived } = useService(useSingle)()

	const location = useLocation()

	const options = () => {
		return [
			{ id: '/', label: 'Overview', disabled: false },
			{ id: 'chat', label: 'Chat', disabled: isArchived() },
			{ id: 'chart', label: 'Chart' },
			// { id: 'journal', label: 'Journal', disabled: false },
			// { id: 'analysis', label: 'Analysis', disabled: false },
		]
	}

	createEffect(() => {
		const getRelativePath = () => {
			const parts = location.pathname.split('/').slice(3) // Adjust based on your route depth
			return parts.join('/') || '/' // Ensure it defaults to "/"
		}

		setPath(getRelativePath())
	})

	return (
		<SegmentGroup.Root
			colorPalette="tscGreen"
			defaultValue={options()[0].id}
			{...props}
			value={path()}
			display={{
				base: 'flex',
				mdDown: 'none',
			}}
		>
			<For each={options()}>
				{(option) => (
					<A
						href={option.id === '/' ? '' : option.id}
						class={css({
							color: option.disabled ? 'gray.7' : '',
							height: '8',
						})}
					>
						<SegmentGroup.Item
							value={option.id}
							class={css({
								pointerEvents: option.disabled ? 'none' : 'all',
							})}
						>
							{option.label}
						</SegmentGroup.Item>
					</A>
				)}
			</For>
			<SegmentGroup.Indicator />
		</SegmentGroup.Root>
	)
}
